import dayjs from "dayjs";
import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { getElementFromId } from "../../../components/funcForInput";
import removeAllErrorMsg from "../../../components/funcRemoveAllErros";
import funcSleep from "../../../components/funcSleep";
import LoadingModal from "../../../components/loadingModal";
import { ApiEndpoints, reqPostNew } from "../../../config/apiClient";
import { getCookie } from "../../../config/cookies";
import styles from "./styles.module.css";

export default function FormFinalizarDocumento({ documentoDados, handleVoltar }: iProps) {
    const [showDataLimite, setShowDataLimite] = useState<boolean>(documentoDados.data_limite === null ? false : true);
    const [loading, setLoading] = useState<boolean>(false)

    async function finalizarConfiguracao() { 
        removeAllErrorMsg();
        const form: any = getElementFromId("formNovoDocumento");
        let dadosValidados = true
        
        let dados = {
            id: documentoDados.id,
            codigo: documentoDados.codigo,
            id_usuario: Number(getCookie("id_user")),
            envio_automatico: form.documento_envio_automatico.checked ? 1 : 0,
            data_limite: form.documento_data_limite.checked ? form.data_limite.value : null,
            recusar: form.documento_permitir_recusar.checked ? 1 : 0,
        }
        if (form.documento_data_limite.checked) { 
            if (dados.data_limite === null) {
                form.data_limite.nextElementSibling.style.display = "block";
                dadosValidados = false;
            } else { 
                let data_limite = String(dados.data_limite)
                let data_limite_aux = dayjs(data_limite)
                let data_atual = dayjs().subtract(1, 'day')
                if (data_limite_aux < data_atual || data_limite.length !== 10) { 
                    form.data_limite.nextElementSibling.style.display = "block";
                    dadosValidados = false;
                }
            }
        }
        
        console.log(dados)
        if (!dadosValidados) { 
            return
        }
        salvarDefinicoes(dados)
    }
    
    async function salvarDefinicoes(dados: any) { 
        setLoading(true)
        const api = await reqPostNew(ApiEndpoints.documentoFinalizar, dados)
        setLoading(false)
        if (api.status === 200) {
            toast.success("Documento configurado com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(500)
            window.location.assign(`/documento?id=${dados.codigo}`)
        }
    }
    
    return (
        <div id="documento_finalizar">
            <h2>Definições do Documento</h2>
            <br></br>
            
            <LoadingModal
                show={loading}
                handleClose={(event: any) => {
                    setLoading(!loading);
                }}
            />

            <Form.Check type="switch" id="documento_envio_automatico" label="Enviar automaticamente links aos signatários" className={styles.inputCheck} defaultChecked={false} />
            <Form.Check type="switch" id="documento_data_limite" label="Definir data limite de assinatura" className={styles.inputCheck} defaultChecked={documentoDados.data_limite === null ? false : true} onChange={(event) => { setShowDataLimite(event.target.checked) }} />
            {showDataLimite && (
                <div style={{ width: "max-content" }}>
                    <Form.Group>
                        <Form.Control name="data_limite" type="date" autoComplete="off" id="data_limite" defaultValue={documentoDados.data_limite} />
                        <Form.Control.Feedback type="invalid">Informe uma data limite válida!</Form.Control.Feedback>
                    </Form.Group>
                    <br></br>
                </div>
            )}
            <Form.Check type="switch" id="documento_permitir_recusar" label="Permitir Recusar Documento" className={styles.inputCheck} defaultChecked={documentoDados.recusar === 0 ? false : true} />

            <br></br>
            <div className="div-row">
                <Button
                    onClick={() => {
                        handleVoltar();
                    }}
                    variant="primary"
                    style={{ height: "40px", marginRight: "10px" }}
                    className="div-row-space-between"
                >
                    <span className="material-symbols-outlined">arrow_back</span> Voltar
                </Button>
                <Button
                    onClick={() => {
                        finalizarConfiguracao()
                    }}
                    variant="success"
                    style={{ height: "40px", marginRight: "10px" }}
                    className="div-row-space-between"
                >
                    Finalizar Configuração <span className="material-symbols-outlined">priority</span>
                </Button>
            </div>
        </div>
    );
}
interface iProps {
    documentoDados: any;
    handleVoltar: any;
}
